module.exports = __webpack_public_path__ + "img/terms-pdf-6.ba30f0c0.jpg";